import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Typography, Grid, Card } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { remCalc } from '@monorepo/shared/src/util/style-util';
import useAssignments from 'state/hooks/use-assignments';
import AssignmentCardMenu from './AssignmentCardMenu';
import AssignmentLetterLabels from './AssignmentLetterLabels';
import { AppRoutes } from 'types';

type Props = {
  letter: string;
};

const AssignmentCard: React.FC<Props> = ({ letter }) => {
  const classes = useStyles();
  const [{ assignments, allGroups }] = useAssignments();
  const navigate = useNavigate();
  const cardText = `${letter?.toUpperCase()}${letter?.toLowerCase()}`;

  const letterAssignments = assignments?.find(
    (d) => d.character.character.toLowerCase() === letter.toLowerCase()
  );

  const isAssignedToAllGroups = letterAssignments?.groups?.length === allGroups?.length;

  const hasAnyAssignments =
    letterAssignments?.groups?.length || letterAssignments?.students?.length;

  const handleCardClick = () => {
    const route = hasAnyAssignments
      ? `/${AppRoutes.ASSIGNMENTS}/edit/${letter}`
      : `/${AppRoutes.ASSIGNMENTS}/${letter}`;
    navigate(route);
  };

  return (
    <Grid container item spacing={1} xs={4} md={3} lg={2} xl={2}>
      <Card className={classes.card} onClick={handleCardClick}>
        <Box display="flex" flexDirection="column" justifyContent="space-between" margin="5px 10px">
          <Box margin="10px" style={{ display: 'flex', justifyContent: 'space-between' }}>
            <Typography variant="h5" className={classes.cardText}>
              {cardText}
            </Typography>
            <Box margin="7px 0">
              <AssignmentCardMenu
                assignments={letterAssignments}
                letter={letter}
                isAssigningALetter={!hasAnyAssignments}
              />
            </Box>
          </Box>
          <Box>
            <AssignmentLetterLabels
              students={letterAssignments?.students}
              groups={letterAssignments?.groups}
              assignedToAllGroups={isAssignedToAllGroups}
              allGroups={allGroups}
            />
          </Box>
        </Box>
      </Card>
    </Grid>
  );
};

const useStyles = makeStyles(() => ({
  card: {
    height: 136,
    width: 300,
    margin: 10,
    cursor: 'pointer',
  },
  cardText: {
    fontSize: remCalc(24),
  },
}));

export default AssignmentCard;
